<template>
<!-- eslint-disable max-len -->
<list-page
  name="Gamulation Set"
  use="_id"
  :display="display"
  page-prefix="/blade/gamesets"
  :fetch="getGameSets"
  :remove="deleteGameSet"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  methods: {
    ...mapActions([
      'getGameSets',
      'deleteGameSet'
    ]),
    display({ name: gameName, demo, updated, completed, professor }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${gameName}${demo ? ' (ACTIVE)' : ''}${completed ? ' (COMPLETED)' : ''}${professor ? ' (PROFESSOR)' : ''} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/GameSetList.vue